import { IMessageRecipient } from 'Modules/Communication/shared/models/Inbox'
import { ISendSmsSettings } from 'shared/models/Message'
import regex from '@bbl-digital/snorre/lib/globals/validation/regularExpressions'
import {
  charsInMultipleSms,
  charsInSingleSms,
} from '../constants/sms-constants'

export const isSendAllowed = (smsSettings: ISendSmsSettings) =>
  smsSettings &&
  (!smsSettings.maxLimit ||
    smsSettings.numberOfSmsNotInvoiced < smsSettings.maxLimit) &&
  smsSettings.isSmsAvailable

export const getTotalSmsCount = (contentChars: number) =>
  contentChars <= charsInSingleSms
    ? 1
    : Math.ceil(contentChars / charsInMultipleSms)

export const getMaxCountForCurrentSms = (contentChars: number) => {
  const smsCount = getTotalSmsCount(contentChars)
  return smsCount === 1 ? charsInSingleSms : smsCount * charsInMultipleSms
}

export const isValidMobileNumber = (mobile: string): boolean =>
  regex.mobilenumber.test(mobile)

// remove whitespace and all valid country codes (norway)
export const getStrippedMobileNumber = (mobile?: string) =>
  (mobile || '')
    .replace(/ /g, '')
    .replace(/^(\+47)/, '')
    .replace(/^(0047)/, '')

export const getUniqueValidRecipientsCount = (
  recipients: IMessageRecipient[]
): number => {
  const uniquePhoneNrs = recipients
    .map((rec) => rec.phonenumber)
    .filter((value, index, self) => {
      const selfCompare = self.map((mobile) => getStrippedMobileNumber(mobile))

      return selfCompare.indexOf(getStrippedMobileNumber(value)) === index
    })

  return uniquePhoneNrs.filter(
    (mobile) => mobile?.trim() && isValidMobileNumber(mobile)
  ).length
}
